// extracted by mini-css-extract-plugin
module.exports = {"subheader_wrapper":"subheader_subheader_wrapper__7C_BJ","title":"subheader_title__1waSR","menuBtn":"subheader_menuBtn__1Pt_0"};